module.exports = __webpack_public_path__ + "img/mb_bg.91055c8.webp";